var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconVoted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.98569 13.2023L9.39611 18.5383C9.64351 18.8372 10.0117 19.0107 10.3998 19.0107C10.7878 19.0107 11.156 18.8372 11.4034 18.5383L21.8268 5.92787C22.2847 5.37422 22.207 4.55235 21.6529 4.09454C21.0992 3.63672 20.2779 3.71485 19.8195 4.26902L10.3998 15.6648L6.99298 11.5435C6.53517 10.9893 5.71382 10.9117 5.15965 11.3695C4.60601 11.8273 4.52788 12.6487 4.98569 13.2023V13.2023Z",
    fill: props.fillSecondary
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 23,
    height: 23,
    rx: 11.5,
    stroke: props.fillSecondary,
    strokeWidth: 2
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVoted);
export default __webpack_public_path__ + "static/media/icon_voted.36ef048fa1679f2a965cffe37a507a14.svg";
export { ForwardRef as ReactComponent };